import styled from 'styled-components';
import { Z_INDEX } from '@/config/ui/zIndex';
import { PALETTE_COLORS, SEMANTIC_COLORS } from '@/constant/unit/color';
import { DEVICE } from '@/constant/unit/device';
export const S = {
    Overlay: styled.div `
    position: fixed;
    top: 0;
    left: 50%;
    transform: translateX(-50%);

    z-index: ${Z_INDEX.MODAL};

    display: flex;
    align-items: center;
    justify-content: center;

    /* set width to inherit to make a position-fixed element fit parent's width */
    width: inherit;
    max-width: inherit;
    height: 100vh;

    background: rgb(56 55 53 / 10%);
    mix-blend-mode: normal;
    backdrop-filter: blur(4px);
  `,
    Body: styled.div `
    display: flex;
    flex-direction: column;
    align-items: center;

    width: fit-content;
    max-width: calc(100% - 60px);
    max-height: calc(100vh - 60px);
    padding: 20px;

    overflow-y: auto;
    font-size: 18px;

    /* title style */
    font-weight: 500;
    line-height: 26px;
    color: ${(props) => props.isError ? SEMANTIC_COLORS.ERROR_TITLE : SEMANTIC_COLORS.DEFAULT_TITLE};
    text-align: center;

    background: ${SEMANTIC_COLORS.DEFAULT_MODAL_BACKGROUND};
    border-radius: 10px;

    @media ${DEVICE.mobileM} {
      padding: 30px 35px;
    }
  `,
    LayoutButtons: styled.div `
    display: flex;
    justify-content: center;
    width: calc(100% - 30px);
    margin-top: 25px;
  `,
    Space: styled.div `
    width: ${(props) => `${props.width}px`};
  `,
    Img: styled.img `
    height: 140px;
    margin-bottom: 10px;
  `,
    TextBlack: styled.div `
    font-size: 16px;
    font-weight: 500;
    line-height: 28px;
  `,
    CountDown: styled.div `
    display: flex;
    align-items: center;
    justify-content: center;

    width: 40px;
    height: 40px;
    margin-top: 12px;

    font-size: 24px;
    font-weight: 700;

    color: ${PALETTE_COLORS.NEUTRAL_300};
    background: rgb(56 55 53 / 60%);
    border-radius: 5px;
  `,
};
